import { FC, useEffect, useState } from 'react'

import DraftIcon from '../UI/Icons/statuses/Draft'
import PendingApprove from '../UI/Icons/statuses/PendingApprove'
import WaitingIcon from '../UI/Icons/statuses/Waiting'
import ApprovedIcon from '../UI/Icons/statuses/Approved'
import FailedIcon from '../UI/Icons/statuses/Failed'
import { definePostSocialStatus } from '../../models/postStatuses'

import './SocialPostStatus.scss'
import { TUser } from '../../models'
import { POST_SOCIAL_STATUS } from '../../models/post'

interface ISocialPostStatusProps {
  status: POST_SOCIAL_STATUS | null
  className: string
  user?: TUser | null
}

const SocialPostStatus: FC<ISocialPostStatusProps> = ({ className, status, user = null }) => {
  const [statusIcon, setStatusIcon] = useState<any | null>(null)
  const [statusText, setStatusText] = useState<string | null>(null)
  const [handledStatus, setHandledStatus] = useState<string | null>(null)

  useEffect(() => {
    if (!status) return setStatusText(`Not saved`)

    const handledStatus = definePostSocialStatus(status, user?.agency_role) as string
    setHandledStatus(handledStatus)

    switch (handledStatus) {
      case 'draft':
        setStatusIcon(<DraftIcon />)
        setStatusText('Draft')
        break
      case 'requires_revision':
        setStatusIcon(<WaitingIcon />)
        setStatusText('Waiting for fixes')
        break
      case 'pending_approval':
        setStatusIcon(<PendingApprove />)
        setStatusText('Sent for Approval')
        break
      case 'approved':
        setStatusIcon(<ApprovedIcon />)
        setStatusText('Approved')
        break
      case 'publishing_failed':
        setStatusIcon(<FailedIcon />)
        setStatusText('Publishing Failed')
        break
      case 'skip_approved':
        setStatusIcon(<ApprovedIcon />)
        setStatusText('Scheduled')
        break    
      case 'unapproved':
        setStatusIcon(<WaitingIcon />)
        setStatusText('Waiting for fixes')
        break         
      default:
        setStatusText(`Not handled - ${status}`)
    }

    return () => {
      setStatusIcon(null)
      setStatusText(null)
    }
  }, [status])

  return (
    <div className={`${className} status-post-social status-${status}`}>
      {statusIcon}
      {statusText}
    </div>
  )
}

export default SocialPostStatus
